import script from "./SafeLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafeLink.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__